import FeatureTabsLayout from '@/shared/components/FeatureTabsLayout/FeatureTabsLayout'

export default function RoleLayout() {
  return (
    <FeatureTabsLayout
      breadcrumbs={['Admin', 'Platform Configuration', 'User Access', 'Roles']}
      basePath="/roles"
      tabs={[
        { segment: 'active', label: 'Active' },
        { segment: 'deleted', label: 'Deleted' },
      ]}
      shouldShowTabs={(pathname) => pathname.startsWith('/roles/')}
      getActiveSegment={(pathname) =>
        pathname.startsWith('/roles/deleted') ? 'deleted' : 'active'
      }
    />
  )
}
